var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTransactionExpired(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 119,
    height: 119,
    viewBox: "0 0 119 119",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_4310_19079)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 16,
    width: 70.0952,
    height: 70.9998,
    rx: 35.0476,
    fill: "#E8E9EB",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.0476 32C48.5524 32 40 40.5524 40 51.0476C40 61.5429 48.5524 70.0952 59.0476 70.0952C69.5429 70.0952 78.0952 61.5429 78.0952 51.0476C78.0952 40.5524 69.5429 32 59.0476 32ZM68 58.419L58.0952 52.7048C57.5048 52.3619 57.1429 51.7333 57.1429 51.0476V39.619H60.9524V49.9429L69.9048 55.1048L68 58.4V58.419Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 71.3776,
    cy: 64.3332,
    r: 6.66667,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.3776 57.6665C75.0643 57.6665 78.0443 60.6465 78.0443 64.3332C78.0443 68.0198 75.0643 70.9998 71.3776 70.9998C67.6909 70.9998 64.7109 68.0198 64.7109 64.3332C64.7109 60.6465 67.6909 57.6665 71.3776 57.6665ZM73.7709 60.9998L71.3776 63.3932L68.9843 60.9998L68.0443 61.9398L70.4376 64.3332L68.0443 66.7265L68.9843 67.6665L71.3776 65.2732L73.7709 67.6665L74.7109 66.7265L72.3176 64.3332L74.7109 61.9398L73.7709 60.9998Z",
    fill: "#FF000F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_4310_19079",
    x: 0,
    y: 0,
    width: 118.094,
    height: 119,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0980392 0 0 0 0 0.109804 0 0 0 0 0.113725 0 0 0 0.04 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4310_19079"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4310_19079",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransactionExpired);
export default __webpack_public_path__ + "static/media/transactionExpired.a7dde0ff5f23c2ec0b02b2572e0bded6.svg";
export { ForwardRef as ReactComponent };